/*ymaps - add & customize -- start*/
$(document).ready(function () {

    function init() {
        var myMap = new ymaps.Map('mapContacts', {
                center: [56.307037, 43.987185],
                zoom: 14,
                controls: []
            }, {
                searchControlProvider: 'yandex#search'
            }),

            // https://yandex.ru/dev/maps/jsapi/doc/2.1/ref/reference/ClusterPlacemark.html#:~:text=Примеры:-,1.,-// Переменная с описанием
            MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
                '<div class="contacts-map__cluster">{{ properties.geoObjects.length }}</div>'
            ),

            // https://yandex.ru/dev/maps/jsbox/2.1/clusterer_custom_icon/
            clusterer = new ymaps.Clusterer({
                // Зададим массив, описывающий иконки кластеров разного размера.
                clusterIcons: [
                    {
                        href: '/all_front_works/pages/contacts/images/map-group-marker.png',
                        size: [40, 40],
                        offset: [-20, -20]
                    }
                ],
                // Эта опция отвечает за размеры кластеров.
                // В данном случае для кластеров, содержащих до 100 элементов,
                // будет показываться маленькая иконка. Для остальных - большая.
                clusterNumbers: [10],
                clusterIconContentLayout: MyIconContentLayout
            }),

            // Создадим пользовательский макет ползунка масштаба.
            ZoomLayout = ymaps.templateLayoutFactory.createClass("<div class='zoomBtns'>" +
                "<div id='zoom-in' class='zoomBtn zoomBtn_plus'></div>" +
                "<div id='zoom-out' class='zoomBtn zoomBtn_minus'></div>" +
                "</div>", {

                // Переопределяем методы макета, чтобы выполнять дополнительные действия
                // при построении и очистке макета.
                build: function () {
                    // Вызываем родительский метод build.
                    ZoomLayout.superclass.build.call(this);

                    // Привязываем функции-обработчики к контексту и сохраняем ссылки
                    // на них, чтобы потом отписаться от событий.
                    this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                    this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);

                    // Начинаем слушать клики на кнопках макета.
                    $('#zoom-in').bind('click', this.zoomInCallback);
                    $('#zoom-out').bind('click', this.zoomOutCallback);
                },

                clear: function () {
                    // Снимаем обработчики кликов.
                    $('#zoom-in').unbind('click', this.zoomInCallback);
                    $('#zoom-out').unbind('click', this.zoomOutCallback);

                    // Вызываем родительский метод clear.
                    ZoomLayout.superclass.clear.call(this);
                },

                zoomIn: function () {
                    var map = this.getData().control.getMap();
                    map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
                },

                zoomOut: function () {
                    var map = this.getData().control.getMap();
                    map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
                }
            }),
            zoomControl = new ymaps.control.ZoomControl({options: {layout: ZoomLayout}});

        myPlacemark = new ymaps.Placemark([56.311496, 43.987122], {
            hintContent: 'Название ТЦ',
            balloonContent: '<div class="mapBalloonContent">\n' +
                '    <div class="mapBalloonContent__title">Сеть Ювелирных Салонов <br> «Сенат»</div>\n' +
                '    <div class="mapBalloonContent__info">\n' +
                '        <div class="mapBalloonContent__info_p shop__adress">г. Нижний Новгород, ул. Воровского, д.22, оф. 307</div>\n' +
                '        <div class="mapBalloonContent__info_p shop__phone">8 (800) 555-05-29</div>\n' +
                '        <div class="mapBalloonContent__info_p shop__timetable">Режим работы: 09:00-20:00</div>\n' +
                '    </div>\n' +
                '</div>'
        }, {
            // Опции.
            // Необходимо указать данный тип макета.
            iconLayout: 'default#image',
            // Своё изображение иконки метки.
            iconImageHref: '/all_front_works/pages/contacts/images/map-marker.svg',
            // Размеры метки.
            iconImageSize: [36, 50]
        });

        clusterer.add([
            myPlacemark
        ]);
        myMap.geoObjects.add(clusterer);
        myMap.controls.add(zoomControl, {
            position: {
                right: 24,
                top: 32
            }
        });

    }

    // инициализировать карту, если блок под карту есть на странице
    if ($('#mapContacts').length) {
        ymaps.ready(init);
    }
});

/*ymaps - add & customize -- end*/
